import TemplateName from '../enums/templateName'
import ActionHandlerService from '../services/actions-handler.service'
import { globalConstants } from "../constants/globalConstants";
import UtilService from "../services/util.service";
import ChatBotApiService from '../services/chatbot-api.service';
import GlobalStoreService from "../services/global-store.service";
import ActionsCommonService from './actions-common.service';
import ChatHistoryService from "../services/chatHistory.service";
import TrackingMiddlewareService from './tracking-middleware.service';
import TrackingKey from '../enums/trackingKey'
import { SCRIPTS } from "../constants/staticScripts";
import BotSwitchService from '../services/bot-switch.service'
import ScenarioType from '../enums/scenario-type';


export default class ActionHandlerService2 {

    static executeChatIn = (data, resolve, reject, retry_count, chatBotQuery) => {

        let enteredText = chatBotQuery || data.user_response ? data.user_response : data.scenarioResponse.user_res

        ChatBotApiService.chatInScenario(
            "",
            data.scenarioResponse.authToken,
            data.scenarioResponse.response,
            data.scenarioResponse.transactionId,
            data.scenarioResponse.scenario,
            enteredText,
            (data && data.initiateRetry) ? data.initiateRetry : "",
            GlobalStoreService.get("currentBotType"),
            ActionHandlerService2.acceptDynamicParameters(data.scenarioResponse),
            ActionHandlerService2.createDynamicParameters(data.scenarioResponse, enteredText)

        ).
            then((response) => {

                let result = response.executionContext

                if (result) {

                    if (result.response && ActionHandlerService2.hasDynamicDescription(result)) {
                        result['response'] = ActionHandlerService.getDynamicDescriptionString(result)
                    }

                    const chatItem = {
                        response: (result && result.response) ? result.response : "",
                        options: ChatHistoryService.addGoToPreviousOption(result, data.scenarioResponse),
                        scenarioActive: (result && result.scenarioActive) ? result.scenarioActive : false,
                        type: "chatbot",
                        sentTime: UtilService.getCurrentTime(),
                        scenarioResponse: (result) ? result : ""
                    }

                    result.scenarioActive = result.scenarioActive || false
                    //replace the exception message with script
                    if (ActionHandlerService.checkIfNeedToReplaceExceptionMessage(result, data.scenarioResponse.templateNameList)) {
                        result.response = SCRIPTS.EXCEPTION_REPLACED_MESSAGE
                    }
                    //check if new intent in chatin to track intent reading success
                    if (ActionHandlerService2.checkIfNewIntentInChatIn(data, result)) {
                        ActionHandlerService.handleTrackingAfterResponse({ enteredText, result, response })
                    }

                    let message_objects = []

                    switch (true) {
                        case (ActionHandlerService.isResponseUnauthorized(response)): {
                            ActionHandlerService2.handleUnauthorizedResponse(result, resolve)
                            break;
                        }
                        case (ActionHandlerService2.isSwitchBotCase(result)): {
                            ActionHandlerService2.handleBotSwitch(result, chatItem, resolve, reject, enteredText, retry_count)
                            break;
                        }
                        case (ActionHandlerService.isProcessingExceptionCase(result)): {
                            chatItem.response = globalConstants.error.genericSRError;

                            message_objects.push({
                                component_type: 'DEFAULT',
                                message: chatItem.response,
                                messageTime: chatItem.sentTime
                            })
                            resolve({ message_objects, scenarioResponse: result, chatItem })
                            break;
                        }
                        case ((result && result.initiateRetry)): {
                            ActionHandlerService2.handleInitiateRetryInReponse(result, retry_count, resolve, reject)
                            break;
                        }
                        case (ActionHandlerService2.isFaqScenario(result)): {
                            ActionHandlerService2.handleFaqScenarioResponse(result, resolve, chatItem)
                            break;
                        }
                        case (result.askForLogin): {
                            ActionHandlerService.showLoginForm(result, resolve)
                            break;
                        }
                        case (ActionHandlerService.isIntentReadingFailResponse(result)): {
                            ActionHandlerService2.handleIntentReadingFailedResponse(resolve, reject)
                            break;
                        }
                        case (ActionHandlerService.isShowDffFormCase(result)): {
                            ActionsCommonService.handleDffForm(result, resolve, reject);
                            break;
                        }
                        case (ActionHandlerService.isDffResponseSuccess(result)): {
                            ActionsCommonService.showDffResponse(result, resolve, reject);
                            break;
                        }
                        case (ActionHandlerService.isCrmConsumeSrApiError(result)): {
                            ActionsCommonService.handleCrmConsumeSrApiError(result, resolve, reject);
                            break;
                        }
                        case (ActionHandlerService2.isCountryTemplate(result)): {
                            ActionHandlerService2.handleCountryTemplate(result, resolve)
                            break;
                        }
                        case (ActionHandlerService2.isIrPackTemplate(result)): {
                            ActionHandlerService2.handleIrPackTemplate(result, chatItem, resolve)
                            break;
                        }
                        case (ActionHandlerService2.hasTemplate(result)): {
                            ActionHandlerService2.handleTemplateResponse(result, chatItem, resolve)
                            break;
                        }
                        case (ActionHandlerService2.isShowAdditionalInfoCase(result)): {
                            // console.log('show additional info')
                            ActionHandlerService2.showAdditionalInfo(result, chatItem, resolve)
                            break;
                        }
                        case ActionHandlerService2.hasResponseString(result): {
                            ActionHandlerService2.handleSimpleResponseCase(result, chatItem, resolve)
                            break;
                        }
                        default: {
                            ActionHandlerService2.handleDefaultErrorMessageCase(reject)
                            break;
                        }
                    }
                }
                else {
                    // no execution context in response
                    //handle default error case
                    ActionHandlerService2.handleDefaultErrorMessageCase(reject)
                }
            }).
            catch((error) => {
                ActionHandlerService2.handleDefaultErrorMessageCase(reject)
            })
    }

    static initiateScenario = (scenarioObject, resolve, reject, retry_count) => {
        ChatBotApiService.initiate(
            "",
            scenarioObject,
            false,
            GlobalStoreService.get("currentBotType"))
            .then((response) => {

                let result = response.executionContext

                if (result) {

                    if (result.response && ActionHandlerService2.hasDynamicDescription(result)) {
                        result['response'] = ActionHandlerService.getDynamicDescriptionString(result)
                    }

                    const chatItem = {
                        response: (result && result.response) ? result.response : "",
                        options: (result && result.scenario && result.scenario.scenarioStep && result.scenario.scenarioStep.options) ? result.scenario.scenarioStep.options : [],
                        scenarioActive: (result && result.scenarioActive) ? result.scenarioActive : false,
                        type: "chatbot",
                        sentTime: UtilService.getCurrentTime(),
                        scenarioResponse: (result) ? result : ""
                    }

                    result.scenarioActive = result.scenarioActive || false

                    let message_objects = []

                    switch (true) {
                        case (ActionHandlerService.isResponseUnauthorized(response)): {
                            ActionHandlerService2.handleUnauthorizedResponse(result, resolve)
                            break;
                        }
                        case (ActionHandlerService.isProcessingExceptionCase(result)): {
                            chatItem.response = globalConstants.error.genericSRError;

                            message_objects.push({
                                component_type: 'DEFAULT',
                                message: chatItem.response,
                                messageTime: chatItem.sentTime
                            })
                            resolve({ message_objects, scenarioResponse: result, chatItem })
                            break;
                        }
                        case ((result && result.initiateRetry)): {
                            ActionHandlerService2.handleInitiateRetryInReponse(result, retry_count, resolve, reject)
                            break;
                        }
                        case (result.askForLogin): {
                            ActionHandlerService.showLoginForm(result, resolve)
                            break;
                        }
                        // case (ActionHandlerService.isIntentReadingFailResponse(result)):{
                        //     ActionHandlerService2.handleIntentReadingFailedResponse(resolve,reject)
                        //     break;
                        // }
                        case (ActionHandlerService2.isCountryTemplate(result)): {
                            ActionHandlerService2.handleCountryTemplate(result, resolve)
                            break;
                        }
                        case (ActionHandlerService2.isIrPackTemplate(result)): {
                            ActionHandlerService2.handleIrPackTemplate(result, chatItem, resolve)
                            break;
                        }
                        case (ActionHandlerService2.hasTemplate(result)): {
                            ActionHandlerService2.handleTemplateResponse(result, chatItem, resolve)
                            break;
                        }
                        case (ActionHandlerService2.isShowAdditionalInfoCase(result)): {
                            // console.log('show additional info')
                            ActionHandlerService2.showAdditionalInfo(result, chatItem, resolve)
                            break;
                        }
                        // case ActionHandlerService2.hasDynamicDescription(result): {
                        //     let dynDesc = ActionHandlerService.getDynamicDescriptionString(result)
                        //     console.log('dynamic desc', dynDesc)
                        //     break;
                        // }
                        case ActionHandlerService2.hasResponseString(result): {
                            ActionHandlerService2.handleSimpleResponseCase(result, chatItem, resolve)
                            break;
                        }
                        default: {
                            ActionHandlerService2.handleDefaultErrorMessageCase(reject)
                            break;
                        }
                    }
                }
                else {
                    // no execution context in response
                    //handle default error case
                    ActionHandlerService2.handleDefaultErrorMessageCase(reject)
                }

            }).
            catch((error) => {
                ActionHandlerService2.handleDefaultErrorMessageCase(reject)
            })
    }

    static executeChatOut = (enteredText, resolve, reject, retry_count, chatBotQuery) => {
        let query = chatBotQuery || enteredText
        const trackingData = GlobalStoreService.get("trackingData");
        trackingData.queryCount += 1;
        GlobalStoreService.set("trackingData", trackingData);
        ChatBotApiService.chatOutScenario(
            query
        ).then((response) => {
            let result = response.executionContext

            if (result) {

                ActionHandlerService.handleTrackingAfterResponse({ enteredText, result, response })

                // if (result.response && ActionHandlerService2.hasDynamicDescription(result)) {
                //     result['response'] = ActionHandlerService.getDynamicDescriptionString(result)
                // }

                const chatItem = {
                    response: (result && result.response) ? result.response : "",
                    options: (result && result.scenario && result.scenario.scenarioStep && result.scenario.scenarioStep.options) ? result.scenario.scenarioStep.options : [],
                    scenarioActive: (result && result.scenarioActive) ? result.scenarioActive : false,
                    type: "chatbot",
                    sentTime: UtilService.getCurrentTime(),
                    scenarioObject: (result && result.scenario) ? result.scenario : ""
                };

                result.scenarioActive = result.scenarioActive || false

                switch (true) {
                    case (ActionHandlerService.isResponseUnauthorized(response)): {
                        ActionHandlerService2.handleUnauthorizedResponse(result, resolve)
                        break;
                    }
                    case (ActionHandlerService2.isSwitchBotCase(result)): {
                        ActionHandlerService2.handleBotSwitch(result, chatItem, resolve, reject, query, retry_count)
                        break;
                    }
                    case ((result && result.initiateRetry)): {
                        ActionHandlerService2.handleInitiateRetryInReponse(result, retry_count, resolve, reject)
                        break;
                    }
                    case (ActionHandlerService.isIntentReadingFailResponse(result)): {
                        ActionHandlerService2.handleIntentReadingFailedResponse(resolve, reject)
                        break;
                    }
                    case (ActionHandlerService2.isFaqScenario(result)): {
                        ActionHandlerService2.handleFaqScenarioResponse(result, resolve, chatItem)
                        break;
                    }
                    case (ActionHandlerService2.isDTScenario(result)): {
                        ActionHandlerService2.handleDtScenario(result, resolve, reject, retry_count)
                        break;
                    }
                    default: {
                        ActionHandlerService2.handleDefaultErrorMessageCase(reject)
                        break;
                    }
                }
            }
            else {
                // no execution context in response
                //handle default error case
                ActionHandlerService2.handleDefaultErrorMessageCase(reject)
            }
        }).catch(error => {
            ActionHandlerService2.handleDefaultErrorMessageCase(reject)
        })
    }

    static isDTScenario = (result) => {
        if (result
            && result.scenario
            && result.scenario.scenarioStrategy === "DTScenario") {
            return true
        }
        return false
    }

    static isSwitchBotCase = (result) => {
        if (result && result.scenario && result.scenario.scenarioLob
            && result.scenario.scenarioLob.toUpperCase() !== GlobalStoreService.get("currentBotType")  
            && result.scenario.scenarioStrategy && result.scenario.scenarioStrategy === "SwitchScenario") {
            // console.log('is switch bot case')
            return true
        }
        return false
    }

    static handleBotSwitch = (result, chatItem, resolve, reject, query, retry_count) => {
        BotSwitchService.handleBotSwitch(result, chatItem, resolve, reject, query, retry_count)
    }

    static handleDtScenario = (result, resolve, reject, retry_count) => {
        if (ActionHandlerService.isLoginRequired(result)) {

            if (GlobalStoreService.get("isUserLoggedIn")) {
                ActionHandlerService2.initiateScenario(result.scenario, resolve, reject, retry_count);
            } else {
                // console.log('handle dt scenario, show login')
                ActionHandlerService.showLoginForm(result, resolve)
            }
        }
        else {
            ActionHandlerService2.initiateScenario(result.scenario, resolve, reject, retry_count);
        }
    }

    static hasTemplate = (result) => {
        if (result.templateNameList && result.templateNameList.length > 0) {
            return true
        }
        return false
    }

    static hasResponseString = (result) => {
        if (result.response !== undefined) {
            return true
        }
        return false
    }

    static handleSimpleResponseCase = (result, chatItem, resolve) => {
        let message_objects = []
        const formattedresponse = ActionsCommonService.getWebOrAppSpecificResponse(
            ActionsCommonService.getPlatformSpeciifcDescription(result.response, result.scenario.scenarioStrategy)
        );
        chatItem.response = formattedresponse;

        const splittedResponse = formattedresponse.split("<div>&gt;&gt;&gt;&gt;</div>");

        for (let i = 0; i < splittedResponse.length; i++) {
            const splittedChatItem = JSON.parse(JSON.stringify(chatItem));
            splittedChatItem.response = splittedResponse[i];

            message_objects.push({
                component_type: 'DEFAULT',
                message: splittedChatItem.response,
                messageTime: splittedChatItem.sentTime
            })
        }

        if (result &&
            result.dffStepResponse &&
            result.dffStepResponse.result &&
            result.dffStepResponse.result.message) {
            const splittedChatItem = JSON.parse(JSON.stringify(chatItem));
            splittedChatItem.response = result.dffStepResponse.result.message;

            message_objects.push({
                component_type: 'DEFAULT',
                message: splittedChatItem.response,
                messageTime: splittedChatItem.sentTime
            })
        }
        // Update Chat History
        ChatHistoryService.addItem({ message_objects, scenarioResponse: result, chatItem: chatItem });
        resolve({ message_objects, scenarioResponse: result, chatItem })

    }

    static handleTemplateResponse = (result, chatItem, resolve) => {

        let template_res = result.response;
        let message_objects = []
        if (result.systemInfo) {

            template_res = ActionHandlerService.getTemplateResponseFromSystemInfo(result.systemInfo, result.templateNameList, result)
            // console.log('template res',template_res)

            if (result.response.indexOf('[json]') !== -1) {
                let res_obj = ActionHandlerService.getTemplateResponseObject(result.response)
                chatItem.response = res_obj.chat_res_string

            }
            message_objects.push({
                component_type: 'DEFAULT',
                message: chatItem.response,
                messageTime: chatItem.sentTime
            })

        }
        else if (result.response.indexOf('[json]') !== -1) {
            let res_obj = ActionHandlerService.getTemplateResponseObject(result.response)
            chatItem.response = res_obj.chat_res_string

            message_objects.push({
                component_type: 'DEFAULT',
                message: chatItem.response,
                messageTime: chatItem.sentTime
            })
            template_res = res_obj.template_res_string

        }
        // let template_obj = ActionHandlerService2.getTemplateMessageObject(template_res,result.templateNameList,chatItem)
        let template_obj = ActionHandlerService.chooseTemplateToShow(result.templateNameList, template_res, chatItem)
        let showCancelButton = ActionHandlerService2.showCancelButton(result.templateNameList, chatItem)

        if (template_obj && template_obj.message_obj) {
            message_objects.push(template_obj.message_obj)
        }

        resolve({
            message_objects,
            scenarioResponse: result,
            chatItem: (template_obj && !template_obj.options_hidden) || !template_obj ? chatItem : undefined,
            show_cancel_comp: template_obj ? template_obj.show_cancel_comp : false,
            bottom_comp: template_obj && template_obj.show_cancel_comp ? { type: globalConstants.BOTTOM_BAR_COMPONENTS.CANCEL_COMPONENT, cancel_obj: { ...template_obj.cancel_obj, chatItem: chatItem } } : undefined,
            cancel_obj: template_obj ? { ...template_obj.cancel_obj, chatItem: chatItem } : undefined
        });

    }

    static showCancelButton = (templateNameList, chatItem) => {
        // console.log('cancel func')
        if (chatItem && chatItem.options && chatItem.options.length > 0) {
            if (chatItem.options.includes((option) => { option.displayText === 'CANCEL' }))
                // console.log('show cancel')
                return true
        }
        // console.log('no cancel')
        return false

    }

    static getTemplateMessageObject = (template_res_string, templateNameList, chatItem) => {
        // console.log('get template object')
        let template_data
        try {
            template_data = JSON.parse(template_res_string)
        }
        catch (e) {
            template_data = undefined
        }
        let template_obj

        if (template_data) {
            template_obj = ActionHandlerService.chooseTemplateToShow(templateNameList, template_res_string, chatItem)
        }
        else {
            //template data not received or not parsable
            if (!templateNameList.includes(TemplateName.IR_RECO_DYN_PARAM)) {

                template_obj = {
                    message_obj: UtilService.createChatBotMessageObject('no template data')
                }
            }
        }
        return template_obj

    }

    static createChatBotMessageObject = (message) => {
        return {
            component_type: 'DEFAULT',
            message: message,
            messageTime: UtilService.getCurrentTime()
        }
    }

    static isIrPackTemplate = (result) => {
        if (result.templateNameList && result.templateNameList.length > 0 &&
            (UtilService.IS_IR_PACKS_RECO(result.templateNameList) || UtilService.IS_IR_PACKS_ALL(result.templateNameList))) {
            return true
        }
        return false
    }

    static handleIrPackTemplate = (result, chatItem, resolve) => {

        chatItem.sentTime = UtilService.getCurrentTime()
        let message_objects = []
        const formattedresponse = ActionsCommonService.getWebOrAppSpecificResponse(
            ActionsCommonService.getPlatformSpeciifcDescription(result.response, result.scenario.scenarioStrategy)
        );
        chatItem.response = formattedresponse;
        let template_res = result.response;
        if (result.systemInfo) {
            template_res = ActionHandlerService.getTemplateResponseFromSystemInfo(result.systemInfo, result.templateNameList, result)
            if (result.response.indexOf('[json]') !== -1) {
                let res_obj = ActionHandlerService.getTemplateResponseObject(result.response)
                chatItem.response = res_obj.chat_res_string
            }
            message_objects.push({
                component_type: 'DEFAULT',
                message: chatItem.response,
                messageTime: chatItem.sentTime
            })
        }

        else if (result.response.indexOf('[json]') !== -1) {
            let res_obj = ActionHandlerService.getTemplateResponseObject(result.response);
            chatItem.response = res_obj.chat_res_string

            message_objects.push({
                component_type: 'DEFAULT',
                message: chatItem.response,
                messageTime: chatItem.sentTime
            })
            template_res = res_obj.template_res_string
        }
        if (template_res) {
            message_objects.push({
                component_type: 'IR_PACK',
                messageTime: UtilService.getCurrentTime(),
                packDetails: template_res,
                chatItem,
                templateName: result.templateNameList[0]
            })
        }
        else {
            message_objects.push({
                component_type: 'DEFAULT',
                message: SCRIPTS.NO_SYSTEM_INFO_MESSAGE,
                messageTime: chatItem.sentTime
            })
        }

        resolve({
            message_objects,
            scenarioResponse: result,
            show_cancel_comp: true,
            bottom_comp: { type: globalConstants.BOTTOM_BAR_COMPONENTS.CANCEL_COMPONENT, cancel_obj: { type: 'IR_PACK', chatItem: chatItem } },
            cancel_obj: { type: 'IR_PACK', chatItem: chatItem },
        });

    }

    static handleCountryTemplate = (result, resolve) => {
        let message_objects = []
        let chatItem = {}
        const formattedresponse = ActionsCommonService.getWebOrAppSpecificResponse(
            ActionsCommonService.getPlatformSpeciifcDescription(result.response, result.scenario.scenarioStrategy)
        );
        chatItem.response = formattedresponse;
        chatItem.sentTime = UtilService.getCurrentTime()

        message_objects.push({
            component_type: 'DEFAULT',
            message: chatItem.response,
            messageTime: chatItem.sentTime
        })
        resolve({ message_objects, scenarioResponse: result })
    }

    static handleUnauthorizedResponse = (result, resolve) => {
        let chatItem = {}
        let message_objects = []
        chatItem.response = globalConstants.SESSION_EXPIRED_STATUS.message;
        chatItem.sentTime = UtilService.getCurrentTime()
        message_objects.push({
            component_type: 'DEFAULT',
            message: chatItem.response,
            messageTime: chatItem.sentTime
        })
        resolve({ message_objects, scenarioResponse: result })
    }

    static isCountryTemplate = (result) => {
        if (result.templateNameList && result.templateNameList.length > 0 && UtilService.isCountryTemplate(result.templateNameList)) {
            return true
        }
        return false
    }

    static handleDefaultErrorMessageCase = (reject) => {
        let chatItem = {}
        chatItem['response'] = globalConstants.default_error_message

        let message_objects = []
        message_objects.push({
            component_type: 'DEFAULT',
            message: chatItem.response,
            messageTime: UtilService.getCurrentTime()
        })
        reject({ message_objects })
    }

    static handleIntentReadingFailedResponse = (resolve, reject) => {
        if (GlobalStoreService.get('no_intent_found_1')) {
            GlobalStoreService.set('no_intent_found_1', false)
            ActionHandlerService2.initiateScenario(GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["NO_INTENT_FOUND_1"], resolve, reject);
        } else {
            GlobalStoreService.set('no_intent_found_1', true)
            ActionHandlerService2.initiateScenario(GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["NO_INTENT_FOUND_2"], resolve, reject);
        }
    }

    static isFaqScenario = (result) => {
        if (result && result.scenario
            && result.scenario.scenarioStrategy === ScenarioType.FAQScenario) {
            return true
        }
        return false
    }

    static handleFaqScenarioResponse = (result, resolve, chatItem) => {
        chatItem = {}
        let message_objects = []
        const formattedresponse = ActionsCommonService.getWebOrAppSpecificResponse(
            ActionsCommonService.getPlatformSpeciifcDescription(result, result.scenario.scenarioStrategy)
        );
        chatItem.response = formattedresponse;

        message_objects.push({
            component_type: 'DEFAULT',
            message: chatItem.response,
            messageTime: chatItem.sentTime
        })
        resolve({ message_objects, scenarioResponse: result })

    }

    static handleInitiateRetryInReponse = (result, retry_count, resolve, reject) => {
        // console.log(retry_count)
        const scenarioName = (result && result.scenario && result.scenario.scenarioName) || "";
        const scenarioStrategy = (result && result.scenario && result.scenario.scenarioStrategy) || "";

        if (!retry_count || retry_count < 3) {

            resolve({ scenarioResponse: result, initiateRetry: result.initiateRetry, retry_count: retry_count ? retry_count : 0 })
            //tracking for retry case
            TrackingMiddlewareService.setTrackingData({ scenarioName, scenarioStrategy })
            TrackingMiddlewareService.trackEvent(TrackingKey.RETRY_OPTION)
        }
        else if (GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")] && GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["FAILURE"]) {
            ActionHandlerService2.initiateScenario(GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["FAILURE"], resolve, reject, retry_count + 1);
        }
        else {
            let chatItem = {}
            chatItem['response'] = globalConstants.default_error_message

            let message_objects = []
            message_objects.push({
                component_type: 'DEFAULT',
                message: chatItem.response,
                messageTime: UtilService.getCurrentTime()
            })
            resolve({ message_objects })
        }
    }

    static checkIfNewIntentInChatIn = (data, result) => {
        if (data &&
            data.scenarioResponse &&
            data.scenarioResponse.scenario &&
            data.scenarioResponse.scenario.scenarioId &&
            result &&
            result.scenario &&
            result.scenario.scenarioId &&
            data.scenarioResponse.scenario.scenarioId !== result.scenario.scenarioId) {
            return true
        }
        return false
    }


    static acceptDynamicParameters = (scenarioResponse) => {

        if (scenarioResponse && scenarioResponse.templateNameList && scenarioResponse.templateNameList.length > 0) {
            let templatesWithDynamicParam = [
                TemplateName.IR_PACKS_ALL,
                TemplateName.IR_PACKS_RECO,
                TemplateName.IR_Pack_Countries,
                TemplateName.IR_RECO_DYN_PARAM,
                TemplateName.IR_ACTIVATED_PACKS_DEACTIVATION
            ]
            for (let i in scenarioResponse.templateNameList) {
                if (templatesWithDynamicParam.includes(scenarioResponse.templateNameList[i])) {
                    return true
                }
            }
            return false
        }
    }

    static createDynamicParameters = (scenarioResponse, user_input) => {

        let templateDynamicParam = {
            IR_PACKS_ALL: 'INPUT_PARAM-IR_BOOSTER_ID_ACTIVE_REQUEST',
            IR_Pack_Countries: 'INPUT_PARAM-IR_BOOSTER_COUNTRY_NAME',
            IR_RECO_DYN_PARAM: 'INPUT_PARAM-IR_BOOSTER_VALIDITY',
            IR_PACKS_RECO: 'INPUT_PARAM-IR_BOOSTER_ID_ACTIVE_REQUEST',
            IR_ACTIVATED_PACKS_DEACTIVATION: 'DEACTIVATION_IR_PACK_ID',
        }

        let dynamicParams = {}

        if (ActionHandlerService2.acceptDynamicParameters(scenarioResponse) && scenarioResponse && scenarioResponse.templateNameList && scenarioResponse.templateNameList.length > 0) {
            for (let i in scenarioResponse.templateNameList) {
                if (templateDynamicParam.hasOwnProperty(scenarioResponse.templateNameList[i])) {
                    dynamicParams[templateDynamicParam[scenarioResponse.templateNameList[i]]] = user_input
                }
            }
        }
        return dynamicParams
    }

    static showAdditionalInfo = (scenarioResponse, chatItem, resolve) => {

        let message_objects = [];
        if (scenarioResponse.additionalInfo && Object.keys(scenarioResponse.additionalInfo).length > 0 && scenarioResponse.additionalInfo.leap_informCustomerScript) {
            message_objects.push(UtilService.createChatBotMessageObject(scenarioResponse.additionalInfo.leap_informCustomerScript))
        }
        if (scenarioResponse.response) {
            message_objects.push(UtilService.createChatBotMessageObject(scenarioResponse.response))
        }

        resolve({ message_objects, scenarioResponse: scenarioResponse, chatItem })
    }


    static isShowAdditionalInfoCase = (scenarioResponse) => {
        // console.log(scenarioResponse)
        if (scenarioResponse.scenario && scenarioResponse.scenario.scenarioLob && scenarioResponse.scenario.scenarioLob.toLowerCase() === "prepaid" && scenarioResponse.additionalInfo && Object.keys(scenarioResponse.additionalInfo).length > 0) {
            return true
        }
        return false

    }
    static hasDynamicDescription = (result) => {
        // console.log(result.response, result.response.indexOf('[DYN-DESC]'))
        if (result && result.response && result.response.indexOf('[DYN-DESC]') !== -1) {
            return true
        }
        return false
    }
}


// WEBPACK FOOTER //
// ./src/services/actions-handler.service2.js